import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

function calculateBarStyle(currStep: number, barPosZeroIndexed: number) {
  if (currStep >= barPosZeroIndexed + 1) {
    return "bg-primary-300 border border-primary-500";
  } else {
    return "bg-secondary-100";
  }
}

export const OnboardingTopBar = ({
  onBackClicked,
  backDisabled = false,
  currStep,
  maxSteps,
}: {
  onBackClicked?: () => void;
  backDisabled?: boolean;
  currStep: number;
  maxSteps: number;
}) => {
  return (
    <div className="flex flex-row gap-2 w-full items-center">
      <Button
        variant="secondary"
        disabled={backDisabled}
        size="md"
        className="flex-none"
        onClick={onBackClicked}
      >
        <ChevronLeft className="h-icon-m w-icon-md flex-none" />
        <span>Back</span>
      </Button>
      {[...Array(maxSteps).keys()].map((barPosZeroIndexed) => (
        <div
          key={barPosZeroIndexed + 1}
          className={cn(
            "h-2 flex-1 rounded-full",
            calculateBarStyle(currStep, barPosZeroIndexed)
          )}
        ></div>
      ))}
    </div>
  );
};
